var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{attrs:{"dark":_vm.$store.state.isDarkMode,"headers":_vm.loanHeaders,"items":_vm.form.loan}})
}
var staticRenderFns = []

export { render, staticRenderFns }